{
  "id": "campaign-070",
  "name": "Dewy Dogleg",
  "seed": "campaign:70",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "............",
    "...sTooT....",
    "...sooFo....",
    "...sWooW....",
    "...s........",
    "...s........",
    "............",
    ".T,T....T.T.",
    ".,,.........",
    "..,..~......",
    "..W.~~~#.W,.",
    ".....~....,,",
    "..........,.",
    "...,........",
    "...,,...x..x",
    "...,........",
    "S..........."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 6,
      "y": 16
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 10,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 6
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 12
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 10,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 9
    },
    {
      "kind": "repair",
      "x": 5,
      "y": 14
    }
  ],
  "generatorVersion": 3,
  "level": 70,
  "biome": "golf",
  "par": {
    "reel": 7497,
    "push": 5791,
    "selfPropelled": 5340,
    "tractor": 4380,
    "zeroTurn": 3793,
    "fairway": 2226
  },
  "routeTries": {
    "par": {
      "reel": 13,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 5
    }
  }
}
